import React from 'react'

const BaseMobile: React.FC = ({ children }) => {
  return (
    <>
      {children}
    </>
  )
}

export default BaseMobile
